import React from "react";

export default function HeadquartersPage({
  title,
  subtitle,
  actions,
  children,
}) {
  return (
    <div>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          gap: 16,
          alignItems: "flex-start",
          flexWrap: "wrap",
          marginBottom: 22,
        }}
      >
        <div>
          <h1
            style={{
              margin: 0,
              fontSize: 34,
              lineHeight: 1.1,
              fontWeight: 900,
              color: "#ffffff",
            }}
          >
            {title}
          </h1>

          {subtitle && (
            <p
              style={{
                color: "#9fb0c3",
                marginTop: 8,
                marginBottom: 0,
                fontSize: 16,
              }}
            >
              {subtitle}
            </p>
          )}
        </div>

        {actions && <div>{actions}</div>}
      </div>

      {children}
    </div>
  );
}
